<header>
	<p>
		<ras-menu-button *ngIf="menu" [(active)]="show_menu"></ras-menu-button>
		<a class="logo" [routerLink]="['/']"><img [src]="'/assets/logoRENTASTORE.svg'" alt="RENT-A-STORE"></a>
		<a class="phone-number" href="tel:+27861736827"><span>Call us: </span> 0861&nbsp;73&nbsp;68&nbsp;27</a>
	</p>
	<ras-menu [show]="show_menu" (close)="show_menu = false"></ras-menu>
</header>

<ras-map [show]="show_map" [url]="_mapUrl"></ras-map>
<div id="location-info" [ngClass]="{show_map: show_map}" *ngIf="show_heading">
	<div>
		<div *ngIf="tag" class="tag">{{tag}}</div>
		<div [innerHtml]="headingHtml"></div>
		<div class="description"*ngIf="description">
			{{description}}
			<span class="map-link" *ngIf="_mapUrl" (click)="show_map = !show_map">
				<img [src]="'/assets/iconMap.svg'" alt="">
				<span>{{show_map?'Hide':'Show&nbsp;on'}}{{'&nbsp;'}}map</span>
			</span>
		</div>
	</div>
</div>

<div class="body">
	<ng-content></ng-content>
</div>

<ras-footer [thin]="thin_footer"></ras-footer>
